import React from "react";
import { useTranslation } from "react-i18next";

const CampaignsLoading = () => {
  const { t } = useTranslation("common");

  return (
    <div
      className="ordering-campaigns-surface ordering-campaigns-loading border-border bg-background overflow-x-auto rounded-xl border"
      role="status"
      aria-busy="true"
    >
      <span className="sr-only">{t("states.loading")}</span>
      <table className="w-full min-w-[700px]" style={{ tableLayout: "fixed" }}>
        <colgroup>
          <col style={{ width: "40%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "30%" }} />
        </colgroup>
        <thead>
          <tr className="border-border border-b">
            <th className="px-4 py-4 text-left sm:px-6">
              <div className="bg-card h-3 w-28 animate-pulse rounded" />
            </th>
            <th className="px-4 py-4 text-left sm:px-6">
              <div className="bg-card h-3 w-12 animate-pulse rounded" />
            </th>
            <th className="px-4 py-4 text-center sm:px-6">
              <div className="bg-card mx-auto h-3 w-14 animate-pulse rounded" />
            </th>
            <th className="px-6 py-4 text-center">
              <div className="bg-card mx-auto h-3 w-40 animate-pulse rounded" />
            </th>
          </tr>
        </thead>
        <tbody className="divide-border/50 divide-y">
          {[...Array(5)].map((_, index) => (
            <tr key={index}>
              {/* Campaign Name */}
              <td className="overflow-hidden px-4 py-4 sm:px-6">
                <div className="animate-pulse space-y-2">
                  <div className="bg-card h-4 w-32 rounded sm:w-40" />
                  <div className="bg-card h-3 w-24 rounded sm:w-28" />
                </div>
              </td>

              {/* Type */}
              <td className="px-4 py-4 sm:px-6">
                <div className="flex animate-pulse items-center space-x-2">
                  <div className="bg-card h-4 w-4 rounded" />
                  <div className="bg-card h-4 w-12 rounded sm:w-14" />
                </div>
              </td>

              {/* Status */}
              <td className="px-4 py-4 text-center sm:px-6">
                <div className="bg-card mx-auto h-6 w-14 animate-pulse rounded-full" />
              </td>

              {/* Performance (Open Rate / CTR) */}
              <td className="px-6 py-4">
                <div className="flex animate-pulse items-center justify-center">
                  <div className="space-y-1 px-4">
                    <div className="bg-card mx-auto h-4 w-14 rounded" />
                    <div className="bg-card mx-auto h-3 w-16 rounded" />
                  </div>
                  <div className="border-border h-8 border-r"></div>
                  <div className="space-y-1 px-4">
                    <div className="bg-card mx-auto h-4 w-14 rounded" />
                    <div className="bg-card mx-auto h-3 w-8 rounded" />
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CampaignsLoading;
